export default __webpack_public_path__ + "static/media/greaterThanIcon.e4d358c1.svg";